/** Default marketplace filter on Seller Hub store list (India-first account mix). */
export const DEFAULT_STORE_HUB_REGION = 'IN';

const REGION_NAMES = {
  IN: 'India',
  US: 'United States',
  UK: 'United Kingdom',
  GB: 'United Kingdom',
  DE: 'Germany',
  FR: 'France',
  IT: 'Italy',
  ES: 'Spain',
  CA: 'Canada',
  AU: 'Australia',
  AE: 'UAE',
  SA: 'Saudi Arabia',
  JP: 'Japan',
  MX: 'Mexico',
  BR: 'Brazil',
  NL: 'Netherlands',
  SE: 'Sweden',
  PL: 'Poland',
  TR: 'Turkey',
  SG: 'Singapore',
  BE: 'Belgium',
  EG: 'Egypt',
};

export function normalizeRegionCode(region) {
  if (!region || region === '—') return '';
  return String(region).trim().toUpperCase();
}

export function regionFilterLabel(code) {
  const c = normalizeRegionCode(code);
  if (!c) return 'Unknown';
  const name = REGION_NAMES[c];
  return name ? `${name} (${c})` : c;
}

/** Unique region codes present in the store list, sorted with IN first then A–Z. */
export function listStoreRegionCodes(stores = []) {
  const counts = new Map();
  stores.forEach((s) => {
    const c = normalizeRegionCode(s.region);
    if (!c) return;
    counts.set(c, (counts.get(c) || 0) + 1);
  });
  const codes = [...counts.keys()];
  codes.sort((a, b) => {
    if (a === DEFAULT_STORE_HUB_REGION) return -1;
    if (b === DEFAULT_STORE_HUB_REGION) return 1;
    return a.localeCompare(b);
  });
  return codes.map((code) => ({ code, count: counts.get(code) || 0 }));
}

export function storeMatchesRegionFilter(store, regionFilter) {
  if (!regionFilter || regionFilter === 'all') return true;
  return normalizeRegionCode(store.region) === normalizeRegionCode(regionFilter);
}
